import { IApplicationState } from '../../types/redux';

export const selectH1Tag = (state: IApplicationState) => state.landing.seoData?.h1 || 'Подберите свою ипотеку';
